import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SalesInvoice } from '../billing/sales-invoice';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-sales-invoice-detail',
  templateUrl: './sales-invoice-detail.component.html',
  styleUrls: ['./sales-invoice-detail.component.css']
})
export class SalesInvoiceDetailComponent implements OnInit {

  selectedInvoice!: SalesInvoice;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let invoiceId = this.route.snapshot.paramMap.get("invoiceId");
    this.httpService.getInvoiceById(Number(invoiceId)).subscribe(res => {
      this.selectedInvoice = res;
    });
  }

  downloadSalesInvoice() {
    this.httpService.getSalesInvoicePdfById(this.selectedInvoice.id).subscribe(blob => {
      let pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Invoice_" + this.selectedInvoice.invoiceNumber + ".pdf";
      link.click();
    });
  }

}
